onInteractive(function() {
	const editing = document.body.hasAttribute('data-editor-mode');
	const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	// On the homepage the menu bar sits below the full-screen landing and sticks to the top once the landing has scrolled away.
	const landing = document.querySelector('.content-subtemplate-home .landing');
	const header = document.querySelector('.nav-header');
	if (landing && header) {
		const update = function() {
			// The bar wraps to more rows on tablets, so the landing reserves its measured height.
			document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
			header.classList.toggle('is-fixed', window.scrollY >= landing.offsetHeight);
		};
		window.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);
		update();
	}

	// Cover photos are cropped to fill their box, so the browser needs the rendered width of the whole photo to pick a sharp source.
	const coverPictures = document.querySelectorAll('.landing picture, .section-band > .section-background picture');
	const updateSizes = function() {
		coverPictures.forEach(function(picture) {
			const image = picture.querySelector('img');
			if (!image || !image.getAttribute('width') || !image.getAttribute('height')) {
				return;
			}
			const box = image.getBoundingClientRect();
			const ratio = image.getAttribute('width') / image.getAttribute('height');
			const width = Math.ceil(Math.max(box.width, box.height * ratio));
			picture.querySelectorAll('source, img').forEach(function(element) {
				element.setAttribute('sizes', width + 'px');
			});
		});
	};
	updateSizes();
	window.addEventListener('resize', updateSizes);

	// The training video starts by itself once it scrolls into view. The embed only loads its iframe on a click on the preview,
	// so the preview gets that click; the video url carries mute=1 because browsers block autoplay with sound.
	const videos = document.querySelectorAll('.section-video .embed-preloader');
	if (videos.length && !editing && 'IntersectionObserver' in window) onComplete(function() {
		const videoObserver = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					videoObserver.unobserve(entry.target);
					entry.target.click();
				}
			});
		}, { threshold: 0.25 });
		videos.forEach(function(preloader) {
			videoObserver.observe(preloader);
		});
	});

	// Product tiles drop in one after another when they scroll into view; tiles already visible on load stay put.
	const tiles = document.querySelectorAll('.product-tiles > [data-partial="image"]');
	if (tiles.length && !editing && !reducedMotion && 'IntersectionObserver' in window) {
		const hidden = Array.from(tiles).filter(function(tile) {
			return tile.getBoundingClientRect().top > window.innerHeight * 0.9;
		});
		hidden.forEach(function(tile) {
			tile.classList.add('nc-reveal');
		});
		if (hidden.length) {
			const observer = new IntersectionObserver(function(entries) {
				if (!entries.some(function(entry) { return entry.isIntersecting; })) {
					return;
				}
				hidden.forEach(function(tile, index) {
					setTimeout(function() {
						tile.classList.add('is-in');
					}, 300 * index);
				});
				observer.disconnect();
			}, { rootMargin: '0px 0px -100px 0px' });
			observer.observe(hidden[0].parentElement);
		}
	}
});
